import React from 'react'

//assets
import '../assets/css/Events.css'

//Component
import Card from './Card';
import AddEvent from './AddEvent';

//store
import events from '../store/events';
import { observer } from 'mobx-react';
import profile from '../store/profile';

//config
import config from '../config';

//plugin
import axios from 'axios';


@observer

class Events extends React.Component {

  clickCard = (id, type) => {
    events.list.map((x, ind) => {
      if (ind === id && type === "open") {
        x.extend = true;
      } else {
        x.extend = false;
      }
      return x;
    })
  }
  componentWillUnmount = () => {
    console.log('111111111111')
    events.list.map(x => {
      x.extend = false
      return x;
    })
  }

  render() {
    return (
      <div className="Events">
        {events.list.map((x, y) => <Card clickCard={this.clickCard} extend={x.extend} key={x.name + y} name={x.name} type={x.type} data={x.data} id={y} eventAPIKey={x.eventAPIKey} />)}
        <AddEvent />
      </div>
    )
  }
}

export default Events;



// WEBPACK FOOTER //
// ./src/components/Events.js